import { LoadableAfterPaint } from '@confluence/loadable';

export const EditorAppearanceButton = LoadableAfterPaint({
	loader: async () => {
		const { EditorAppearanceButtonComponent } = await import(
			/* webpackChunkName: "loadable-EditorAppearanceButtonComponent" */ './EditorAppearanceButtonComponent'
		);
		return EditorAppearanceButtonComponent;
	},
});

export const EditorAppearanceButtonNext = LoadableAfterPaint({
	loader: async () => {
		const { EditorAppearanceButtonNext } = await import(
			/* webpackChunkName: "loadable-EditorAppearanceButtonNext" */ './EditorAppearanceButtonNext'
		);
		return EditorAppearanceButtonNext;
	},
});

export type {
	EditContentAppearanceButtonStateProps,
	EditContentAppearanceButtonActionProps,
	EditContentAppearanceButtonOwnProps,
} from './types';
